(ns frontend.view.grid.oppos-grid.view
  (:require
   [common.attribute :as attribute]
   [common.entity :as entity]
   [common.fields.table-column-widths :as widths]
   [common.import-permissions :as import-permissions]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.status :as statuses]
   [common.sync-progress :as sync-progress]
   [common.teams :as teams]
   [common.util :as cu]
   [frontend.actions.deal :as deal-actions]
   [frontend.db :as app-db]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.react.virtualized.scrollable-grid.components :as grid-components]
   [frontend.react.virtualized.scrollable-grid.kanban :as kanban]
   [frontend.react.virtualized.scrollable-grid.view :as scrollable-grid]
   [frontend.react.virtualized.utils :as vu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ux-overhaul.listing.oppo.view :as listing-oppo]
   [frontend.ux-overhaul.listing.pipeline-entity :as pipeline-entity]
   [frontend.utils :as fu]
   [frontend.view.components.grid-filters.view :as grid-filters]
   [frontend.view.entity :as f-entity]
   [frontend.page-components.navbar-components.create-dropdown :as create-dropdown]
   [frontend.view.entity-actions.oppo :as entity-actions-oppo]
   [frontend.view.grid.common.components :as components]
   [frontend.view.grid.common.utils :as grid-utils]
   [frontend.view.grid.oppos-grid.db :as db]
   [frontend.view.grid.oppos-grid.events :as events]
   [frontend.view.modals.bulk-edit-entity.view :as bulk-edit-modal]
   [frontend.view.modals.curtains.pass-curtain.view :as pass-curtain]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.curtains.put-on-hold-curtain.view :as put-on-hold-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.folder-management-check-lists-modal.view :as folder-management-check-lists-modal]
   [frontend.view.modals.folder-management-modal.view :as folder-management-modal]
   [frontend.view.named-view.events :as named-view-events]
   [frontend.view.not-found :as not-found]
   [frontend.view.syncing-data :as sync]
   [potpuri.core :as potpuri]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.editors.entity-creator.view :as creator-editor]))

(defonce select-width 30)

(defn column
  [args]
  (let [{:keys [label attribute field-schema filter-data sorting-disabled? width hover-atom
                recompute-grid-sizes! flex-grow]}
        args
        default-width (-> (widths/get-column-width attribute)
                          :default-width
                          (or widths/default-width))]
    {:label               label
     :data-key            attribute
     :field-schema        field-schema
     :filter-data         filter-data
     :update-filter!      (fn [k filter-data]
                            (grid/set-filter (events/setup-args) k filter-data))
     :sort-disabled?      (boolean sorting-disabled?)
     :min-width           (-> (widths/get-column-width attribute)
                              :min-width
                              (or widths/min-width))
     :max-width           (-> (widths/get-column-width attribute)
                              :max-width
                              (or widths/max-width))
     :default-width       default-width
     :width               (or width default-width)
     :set-width           width
     :begin-width-update! (partial grid/begin-width-update! hover-atom attribute)
     :update-width!
     (partial grid/update-width! (events/setup-args) recompute-grid-sizes! hover-atom attribute)
     :end-width-update!   (partial grid/end-width-update! hover-atom attribute)
     :get-styling         (partial grid/get-styling hover-atom attribute)
     :flex-grow           flex-grow}))

(defn toolbar-actions
  [{:keys [view-mode new-grid-2023?]}]
  (let [all-teams (->> @session/all-teams
                       (remove :common/disabled?))
        account-teams (teams/resolve-account-teams @session/account all-teams)
        sorted-grid-entities (:sorted-grid-entities @db/deals)
        has-entities? (and sorted-grid-entities
                           (> (count sorted-grid-entities) 0))]
    [{:toolbar-button?  true
      :dropdown-action? true
      :hidden?          (fn []
                          (or (= view-mode :board-mode)
                              new-grid-2023?))
      :ord              2
      :add-ellipsis?    true
      :primary-button?  false
      :on-select        (fn [_]
                          (grid/open-select-columns-curtain (events/setup-args)))
      :label            (if (= view-mode :board-mode)
                          (loc/tr :select-columns)
                          (loc/tr :action/select-columns))}
     (when-not new-grid-2023?
       (grid-utils/export-button {:account-teams  account-teams
                                  :button-ord     3
                                  :grid-state     db/deals
                                  :column-keys-fn events/resolve-column-keys}))

     (when-not new-grid-2023?
       (grid-utils/export-with-persons-button {:account-teams  account-teams
                                               :entity-type    :entity.type/oppo
                                               :grid-state     db/deals
                                               :button-ord     4
                                               :column-keys-fn events/resolve-column-keys}))

     (when (and (tenant-customizations/finindus?)
                has-entities?)
       {:toolbar-button?  true
        :dropdown-action? true
        :hidden?          (fn []
                            (or (not (import-permissions/allow-export? @session/tenant @session/role))
                                (session/is-mobile?)
                                new-grid-2023?))
        :ord              5
        :primary-button?  false
        :on-select        (fn [_]
                            (events/export-finindus-partner-data))
        :label            (loc/tr :action/deals-finindus-partner-export)})

     (when (and (not (session/is-read-only-user?))
                (not (session/deal-creation-flow?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :on-select        (fn [_]
                            (f-entity/open-creator! :entity.type/oppo {}))
        :label            (loc/tr :deal-add-button)})

     (when (and (session/deal-creation-flow?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :sub-menu-side    :left
        :items
        (let [pipeline-id @session/selected-oppo-pipeline
              pipeline @(r/track session/get-entity pipeline-id)
              items (create-dropdown/pipeline-stage-items
                     {:entity-type :entity.type/oppo
                      :pipeline pipeline})]
          items)
        :label (loc/tr :deal-add-button)})

     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              11
        :label            (loc/tr :pipeline-stages)
        :add-ellipsis?    true
        :primary-button?  true
        :on-select        (fn [_]
                            (modals/open-modal!
                             pipeline-settings-curtain/modal-key
                             {:pipeline-id          @session/selected-oppo-pipeline
                              :stage-entity-type    :entity.type/stage
                              :stage-name-attribute :stage/name
                              :pipeline-attribute   :stage/pipeline}))})
     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              12
        :label            (loc/tr :pipeline-folders)
        :add-ellipsis?    true
        :primary-button?  true
        :on-select        (fn [_]
                            (modals/open-modal!
                             folder-management-modal/modal-key
                             {:entity @session/selected-oppo-pipeline-entity}))})
     (when (and (session/is-admin?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              13
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-checklists)
        :primary-button?  true
        :on-select        (fn [_]
                            (modals/open-modal!
                             folder-management-check-lists-modal/modal-key
                             {:entity           @session/selected-oppo-pipeline-entity
                              :check-lists-atom session/check-lists}))})
     {:divider? true
      :dropdown-action? true
      :ord 14}

     (grid-utils/creator-config-item
      {:ord 15
       :entity-type :entity.type/oppo
       :pipeline
       @(r/track session/get-entity @session/selected-oppo-pipeline)})

     (when (= view-mode :board-mode)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              16
        :label            (loc/tr :card-settings)
        :add-ellipsis?    true
        :on-select        (fn [_]
                            (events/open-card-settings!))})
     {:divider? true
      :dropdown-action? true
      :ord 17}

     (grid-utils/preferred-landing-page-toggle {:view-id      :oppos-grid
                                                :pipeline-id  @session/selected-oppo-pipeline
                                                :pipeline-key :oppo-pipeline})]))

(defn toolbar-buttons-renderer
  []
  (let [setup-args (events/setup-args)
        modal-atom (:modal-state setup-args)
        open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
        selected (grid/get-selected-items setup-args)]
    [:div
     {:class "flex gap-2"}
     (if (session/is-read-only-user?)
       [:span (loc/tr :no-grid-actions-for-read-only-user)]
       [:<>
        [components/toolbar-delete-button
         {:max-delete-count   10000
          :selected-items     selected
          :on-delete-clicked! events/delete-selected-clicked}]
        [components/toolbar-bulk-edit-button
         {:max-bulk-edit-count   10000
          :selected-items        selected
          :on-bulk-edit-clicked! open-bulk-edit!}]])]))

(defn open-pass-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
    pass-curtain/modal-key
    {:oppo-id      (:db/id entity)
     :reset-focus! reset-focus!}))

(defn open-on-hold-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
    put-on-hold-curtain/modal-key
    {:oppo-id      (:db/id entity)
     :reset-focus! reset-focus!}))

(defn status-options
  [entity]
  (->> statuses/oppo-status-options
       (remove (fn [status]
                 (cond
                   (= (:oppo/status entity) :oppo.status/on-hold)
                   (some #{(:key status)} [:oppo.status/on-hold :oppo.status/portfolio])

                   (= (:oppo/status entity) :oppo.status/passed)
                   (some #{(:key status)} [:oppo.status/passed :oppo.status/portfolio])

                   (= (:oppo/status entity) :oppo.status/portfolio)
                   (some #{(:key status)}
                         [:oppo.status/passed :oppo.status/portfolio :oppo.status/on-hold])

                   (= (:oppo/status entity) :oppo.status/ok)
                   (= (:key status) :oppo.status/ok))))))

(defn change-status!
  [{:keys [entity new-value reset-focus!]}]
  (let [pass? (and (= new-value :oppo.status/passed)
                   (some #{(:oppo/status entity)} [:oppo.status/ok :oppo.status/on-hold]))
        on-hold? (and (= new-value :oppo.status/on-hold)
                      (some #{(:oppo/status entity)} [:oppo.status/ok :oppo.status/passed]))
        portfolio? (and (= new-value :oppo.status/portfolio)
                        (some #{(:oppo/status entity)} [:oppo.status/ok]))
        resurrect? (and (= new-value :oppo.status/ok)
                        (some #{(:oppo/status entity)}
                              [:oppo.status/portfolio :oppo.status/on-hold :oppo.status/passed]))]
    (cond
      pass?
      (open-pass-curtain! {:entity       entity
                           :reset-focus! reset-focus!})

      on-hold?
      (open-on-hold-curtain! {:entity       entity
                              :reset-focus! reset-focus!})

      portfolio?
      (do
        (entity-actions-oppo/open-portfolio-modal entity)
        (when reset-focus!
          (reset-focus!)))

      resurrect?
      (do
        (deal-actions/*->resurrect
          {:oppo-id (:db/id entity)}
          identity
          (partial logging/error "reactivate!"))
        (when reset-focus!
          (reset-focus!)))

      :else nil)))

(defn create-props-atom
  [selected sorted-grid-entities filters grid-store
   recompute-grid-sizes! hover-atom modal-atom pipeline]
  (let [tenant-schema @session/tenant-schema
        columns
        (vec (keep (fn [k]
                     (let [field-schema (registry/get-field-schema tenant-schema k)
                           label (attribute/attribute-label tenant-schema k)]
                       (column {:label                 label
                                :attribute             k
                                :field-schema          field-schema
                                :filter-data           (get filters k)
                                :sorting-disabled?     false
                                :width                 (grid/get-saved-width (events/setup-args) k)
                                :hover-atom            hover-atom
                                :recompute-grid-sizes! recompute-grid-sizes!
                                :flex-grow             1})))
                   (events/resolve-column-keys)))
        editable-grid? (and (session/has-feature-access? :feature/editable-grid)
                            @session/editable-grid?)]
    (r/atom
      {:grid-store              grid-store
       :pipeline                pipeline
       :setup-args              (events/setup-args)
       :grid-entities           sorted-grid-entities
       :grid-entity-ids         (->> sorted-grid-entities
                                     (mapv :db/id)
                                     (into #{}))
       :selected                selected
       :link-to-entity-field    :oppo/name
       :header-height           50
       :editable-grid?          editable-grid?
       :select-width            select-width
       :min-columns-width       40
       :height                  (- (or (:height @app-db/window) 400)
                                   (or (:fixed-navbars-height @app-db/window) 0)
                                   75)                      ;; TODO: lazy - fixed 120px for button row in this view
       :avail-height            (- (or (:height @app-db/window) 400)
                                   (or (:fixed-navbars-height @app-db/window) 0)
                                   75)                      ;; TODO: lazy - fixed 120px for button row in this view
       :useDynamicRowHeight     false                       ;; TODO: kebab-case
       :row-height              40                          ;(fn [index] 40)
       :row-count               (if (sequential? sorted-grid-entities)
                                  (count sorted-grid-entities)
                                  0)
       :scrollToIndex           0
       :overscan-count          1
       :columns                 columns
       :no-rows-renderer        (r/partial grid/default-no-rows-render @db/deals :entity.type/oppo)
       :read-only-fields        [:oppo/last-hold-comment
                                 :oppo/last-pass-comment
                                 :oppo/on-hold-until
                                 :oppo/pass-reason
                                 :oppo/pass-reason-v2
                                 :oppo/put-on-hold
                                 :oppo/pipeline]
       :status-options          status-options
       :pipeline-key            :oppo/pipeline
       :owner-key               :oppo/owner
       :status-key              :oppo/status
       :on-row-click!           (fn [row]
                                  (let [data (when (< row (count sorted-grid-entities))
                                               (nth sorted-grid-entities row))]
                                    (routing/open-entity (:db/id data))))
       :on-cell-click           (fn [row col]
                                  (grid/handle-cell-click!
                                    {:columns              columns
                                     :col                  col
                                     :row                  row
                                     :sorted-grid-entities sorted-grid-entities
                                     :state                hover-atom}))
       :change-status!          change-status!
       :is-sorted-by?           (partial grid/is-sorted-by db/view-settings)
       :is-secondary-sorted-by? (partial grid/is-secondary-sorted-by db/view-settings)
       :sort-by!                (fn [k dir]
                                  (grid/set-sort-by (events/setup-args) k dir))
       :reorder-columns!        (fn [dragged-column after-column]
                                  (grid/reorder-columns! (events/setup-args)
                                                         dragged-column
                                                         after-column))
       :can-filter?             (constantly true)
       :resizing-column         (some-> @hover-atom
                                        (get :resize-start-width)
                                        (first)
                                        (key))
       :recompute-grid-sizes!   recompute-grid-sizes!
       :all-selection!          (fn []
                                  (let [selected (:selected @db/deals)]
                                    (if (or (= :all selected) (not-empty selected))
                                      (grid/clear-selection! (events/setup-args))
                                      (swap! db/deals assoc :selected :all))))
       :select-action-renderer  toolbar-buttons-renderer
       :on-row-select!          (fn [index checked]
                                  (let [data (when (< index (count sorted-grid-entities))
                                               (nth sorted-grid-entities index))
                                        oppo-id (:db/id data)]
                                    (if (= selected :all)
                                      (grid/select-all-but (events/setup-args) oppo-id)
                                      (if (boolean checked)
                                        (swap! db/deals assoc-in [:selected oppo-id] true)
                                        (swap! db/deals potpuri/dissoc-in [:selected oppo-id])))))
       :deselect-entity!        (fn [entity-id]
                                  (if (= selected :all)
                                    (grid/select-all-but (events/setup-args) entity-id)
                                    (swap! db/deals potpuri/dissoc-in [:selected entity-id])))
       :row-data-getter         (r/partial grid/default-row-data-getter
                                           sorted-grid-entities
                                           selected)

       :new-action-view         {:in-use?         true
                                 :open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
                                 :bulk-delete!    events/delete-selected-clicked
                                 :modal-atom      modal-atom}})))

(defn og-render
  [grid-store _view-mode]
  (let [hover-atom (r/atom {:hover {:col nil :row nil}})

        entity-type :entity.type/oppo

        ;;new-grid-2023? (session/new-grid-2023?)

        ;;for saving grid references:
        recompute-grid-sizes! (fn []
                                (js/setTimeout
                                 (partial vu/recompute-grid-sizes-with-state! grid-store)
                                 0))]
    (fn [grid-store view-mode]
      (let [tenant-schema @session/tenant-schema
            selected (:selected @db/deals)
            filters @db/deal-filters
            all-columns (events/resolve-column-key-universe)
            sorted-grid-entities (:sorted-grid-entities @db/deals)
            setup-args @(r/track events/setup-args)
            modal-atom (:modal-state setup-args)
            pipeline @session/selected-oppo-pipeline-entity
            grid-atom (create-props-atom selected
                                         sorted-grid-entities
                                         filters
                                         grid-store
                                         recompute-grid-sizes!
                                         hover-atom
                                         modal-atom
                                         pipeline)
            card-settings? (:card-settings? @db/kanban)
            show-quick-filters? (:show-quick-filters? @db/deals)
            show-bulk-edit-modal? (:bulk-edit-modal @modal-atom)
            filters-props {:pipeline-id           @session/selected-oppo-pipeline
                           :minimized?            (not show-quick-filters?)
                           :hide-maximize?        true
                           :universal-search?     true
                           :search-placeholder    (loc/tr :search-for-a-deal)
                           :setup-args            (events/setup-args)
                           :set-universal-search! (r/partial grid/set-universal-search! setup-args)
                           :set-name-search!      (r/partial grid/set-name-search! setup-args)
                           :hide-named-views?     true
                           :named-views           (events/named-views)
                           :current-view          @db/view-settings
                           :columns               (events/resolve-column-keys)
                           :all-columns           all-columns
                           :get-column-label      (fn [a]
                                                    (attribute/attribute-label @session/tenant-schema a))
                           :set-filter!           (fn [k filter-data]
                                                    (grid/set-filter (events/setup-args) k filter-data))
                           :edit-filter!          (fn [k filter-data]
                                                    (grid/open-filter-curtain
                                                     {:field-key      k
                                                      :field-schema   (registry/get-field-schema tenant-schema k)
                                                      :options        (->> all-columns
                                                                           (map (juxt identity
                                                                                      (partial
                                                                                       registry/get-field-schema
                                                                                       tenant-schema))))
                                                      :pipeline       pipeline
                                                      :current-filter filter-data
                                                      :update-fn!     (fn [k filter-data]
                                                                        (grid/set-filter (events/setup-args)
                                                                                         k
                                                                                         filter-data))}
                                                     nil))
                           :hide-qf-attributes    [:oppo/target-asset
                                                   [:oppo/target-asset :asset/name]
                                                   [:oppo/target-asset :company/company-owner]
                                                   [:oppo/target-asset :company/pfc-responsible]
                                                   :oppo/pipeline
                                                   :oppo/flagged-by
                                                   :oppo/reactivated-by
                                                   :oppo/moved-to-portfolio-by]
                           :load-view!            (fn [named-view]
                                                    (events/load-view! named-view)
                                                    (grid/clear-selection! {:state db/deals}))
                           :save-view!            events/save-current-view!
                           :delete-view!          named-view-events/delete-view!
                           :toggle-minimize!      (fn []
                                                    (events/toggle-quick-filters!)
                                                    (.setTimeout js/window recompute-grid-sizes! 1000))}]
        (if card-settings?
          [kanban/card-settings-view (events/setup-args)]
          [:<>
           [grid-filters/view filters-props]
           [creator-editor/modal-view]
           [:div
            {:class "grid-view ps-4"}
            [:div
             {:class-name (fu/cs "grid-view-content"
                                 (when-not show-quick-filters? "named-views-minimized")
                                 (when (= view-mode :board-mode) "board-view"))}

             (when show-bulk-edit-modal?
               [bulk-edit-modal/view
                {:setup-args   setup-args
                 :entity-type  entity-type
                 :close-modal! #(swap! modal-atom dissoc :bulk-edit-modal)}])

             (if (= view-mode :board-mode)
               [kanban/view
                {:setup-args   (events/setup-args)
                 :card-classes (fn [deal]
                                 (case (:oppo/status deal)
                                   :oppo.status/ok "status-active"
                                   :oppo.status/on-hold "border-warning-regular"
                                   :oppo.status/passed "border-danger-light-border"
                                   :oppo.status/portfolio "border-base-light-border-accent"
                                   "status-unknown"))
                 :card-actions
                 (concat [(kanban/open-entity-action
                           {:entity-type :entity.type/oppo})]
                         (when-not (session/is-read-only-user?)
                           (concat
                            [{:id         "pass-oppo"
                              :label      (loc/tr :pipeline-card-pass-action)
                              :icon       "fal fa-ban"
                              :hidden?    (fn [{:keys [entity]}]
                                            (not (some #{(:oppo/status entity)}
                                                       [:oppo.status/ok :oppo.status/on-hold])))
                              :on-select! open-pass-curtain!}
                             {:id         "put-oppo-on-hold"
                              :label      (loc/tr :pipeline-card-put-on-hold-action)
                              :icon       "fal fa-pause-circle"
                              :hidden?    (fn [{:keys [entity]}]
                                            (not (some #{(:oppo/status entity)}
                                                       [:oppo.status/ok :oppo.status/passed])))
                              :on-select! open-on-hold-curtain!}]
                            [{:id         "portfolio-action"
                              :label      (loc/tr :pipeline-card-portfolio-action)
                              :icon       "fal fa-check"
                              :hidden?    (fn [{:keys [entity]}]
                                            (not (some #{(:oppo/status entity)} [:oppo.status/ok])))
                              :on-select! (fn [{:keys [entity]}]
                                            (entity-actions-oppo/open-portfolio-modal entity))}]
                            [{:id         "reactivate-oppo"
                              :label      (loc/tr :pipeline-card-reactivate-action)
                              :icon       "fal fa-redo-alt"
                              :hidden?    (fn [{:keys [entity _recompute-all!]}]
                                            (not (some #{(:oppo/status entity)}
                                                       [:oppo.status/portfolio :oppo.status/on-hold
                                                        :oppo.status/passed])))
                              :on-select! (fn [{:keys [entity]}]
                                            (deal-actions/*->resurrect
                                             {:oppo-id (:db/id entity)}
                                             identity
                                             (partial logging/error "reactivate!")))}])))}]

               [scrollable-grid/view
                {:props-atom grid-atom
                 :hover-atom hover-atom}])]]])))))

(defn toolbar
  [args]
  (let [view-mode (or (:view-mode @db/view-settings)
                      (:view-mode (ls/get-in (events/ls-path)))
                      (:initial-mode args)
                      :board-mode)
        board-mode? (= view-mode :board-mode)
        card-mode (events/get-card-mode)
        has-empty-groups? (when board-mode?
                            (kanban/has-empty-groups? @(r/track events/setup-args)))
        pipelines (->> @session/all-oppo-pipelines
                       (filter session/has-entity-access?)
                       (remove :common/disabled?)
                       (remove :pipeline/inactive?))
        selected-pipeline-name (->> @session/selected-oppo-pipeline
                                    (get @session/entities)
                                    (entity/display-string))

        new-grid-2023? (session/new-grid-2023?)]
    [:div
     {:class "px-4 py-1 flex items-center justify-between
                   bg-base-light
                   border-b border-solid border-base-light-border-paler"}
     [:div
      {:class "w-full flex justify-between gap-6"}
      [:div
       [:div
        {:class "flex gap-3 items-center"}
        [:div
         {:class "flex items-center gap-1"}
         (if (and (cu/multiple? pipelines)
                  @session/selected-oppo-pipeline)
           [grid-components/pipeline-selector
            {:pipelines            pipelines
             :view-text            selected-pipeline-name
             :select-pipeline!     (fn [id]
                                     (session/set-module! :module/dealflow)
                                     (swap! session/selected-pipelines assoc
                                            :oppo-pipeline
                                            id)
                                     (routing/set-view! [:oppos-grid-with-pipeline :pipeline-id id]))
             :selected-pipeline-id @session/selected-oppo-pipeline}]
           [:div
            {:class "font-semibold"}
            [:label selected-pipeline-name]])
         (when (or board-mode? (not new-grid-2023?))
           [:span
            {:class "h-5 px-2 flex items-center justify-center text-xs font-semibold text-base-light-text bg-complement-regular rounded-full"}
            (count @db/sorted-kanban-entities)])]

        (when (or board-mode? (not new-grid-2023?))
          [grid-components/named-view-selector
           {:named-views               (events/named-views)
            :current-view              @db/view-settings
            :load-view!                (fn [id]
                                         (events/load-view! (events/named-view-by-id id))
                                         (grid/clear-selection! {:state db/deals}))
            :delete-view!              named-view-events/start-delete-view!
            :accounts-with-view-access (session/active-accounts-with-pipeline-access
                                         @session/selected-oppo-pipeline)
            :save-current-view!        events/save-current-view!}])

        (when board-mode?
          [grid-components/sort-selector
           {:view-settings   @db/view-settings
            :entity-type     :entity.type/oppo
            :sortable-fields (events/resolve-column-key-universe)
            :set-sort-by!    (fn [k dir]
                               (grid/set-sort-by (events/setup-args) k dir))}])

        (when board-mode?
          [grid-components/grouped-by-selector
           {:view-settings      @db/view-settings
            :entity-type        :entity.type/oppo
            :default-grouped-by :oppo/stage
            :grouped-by-fields  (->> (events/resolve-column-key-universe)
                                     (remove #{:oppo/status})
                                     (filter grid/groupable-attribute?))
            :set-grouped-by!    (fn [k]
                                  (swap! db/view-settings assoc :grouped-by k)
                                  (ls/update-in (events/ls-path)
                                                assoc
                                                :grouped-by
                                                k))}])]]

      [:div
       {:class "flex justify-content-end items-center gap-2"}
       ;;(when-not board-mode?
       ;;  [grid-components/editable-grid-toggle])
       (when (and board-mode? (not= card-mode :short-card))
         [button/square-secondary-open
          {:on-click (fn [_] (events/collapse-all!))
           :tooltip  (loc/tr :collapse-all)}
          [:i.fal.fa-compress-alt]])
       (when (and board-mode? (= card-mode :short-card))
         [button/square-secondary-open
          {:tooltip  (loc/tr :expand-all)
           :on-click (fn [_] (events/expand-all!))}
          [:i.fal.fa-expand-alt]])

       [button/square-secondary-open
        {:tooltip  (grid-components/view-mode-tooltip board-mode?)
         :on-click (fn [_]
                     (events/switch-mode! view-mode))}
        (if board-mode?
          [:i.fal.fa-table]
          [:i.fal.fa-signal-3.fa-rotate-180.kanban-icon])]

       (when (and board-mode? has-empty-groups?)
         [grid-utils/hide-empty-kanban-groups-toggle "oppos-grid-toolbar" db/kanban])

       [:div.toolbar-dropdown
        (zap-toolbar/dropdown (->> (toolbar-actions {:view-mode      view-mode
                                                     :new-grid-2023? new-grid-2023?})
                                   (filter :dropdown-action?)
                                   (remove (fn [{:keys [hidden?]}]
                                             (when (fn? hidden?)
                                               (hidden?))))
                                   (sort-by :ord))
                              true)]]]]))

(defn view
  [_view-mode]
  (let [close-atom (atom false)
        grid-store (atom {})
        resizer (fn []
                  (js/setTimeout (partial vu/recompute-grid-sizes-with-state! grid-store) 100))]
    (.addEventListener js/window "resize" resizer)
    (r/create-class
      {:component-did-mount    (fn []
                                 (println "Mount grid")
                                 (fu/timeout 10 (partial events/setup close-atom)))
       :component-will-unmount (fn []
                                 (println "Unmount grid")
                                 (reset! close-atom true)
                                 (events/cleanup)
                                 (.removeEventListener js/window "resize" resizer))
       :reagent-render         (fn [view-mode]
                                 [og-render grid-store view-mode])})))

(defmethod routing/render-view :oppos-grid
  [{:keys [initial-mode route-params] :as args}]
  (session/sync-selected-pipeline-from-route!
   {:route-params            route-params
    :pipeline-key            :oppo-pipeline
    :all-pipelines-for-type  session/all-oppo-pipelines})
  (if (session/new-grid-2023?)
    [pipeline-entity/render-page listing-oppo/config]
    (let [forbidden? (or (not (session/dealflow?))
                         (and (not (session/is-admin?))
                              (->> @session/all-oppo-pipelines
                                   (filter session/has-entity-access?)
                                   (empty?))))
          no-pipeline-in-use? (and (session/dealflow?)
                                   (session/is-admin?)
                                   (->> @session/all-oppo-pipelines
                                        (every? :pipeline/inactive?)))

          view-mode (or (:view-mode @db/view-settings)
                        (:view-mode (ls/get-in (events/ls-path)))
                        initial-mode
                        :board-mode)]
      (cond
        forbidden?
        [not-found/not-found-view]
        no-pipeline-in-use?
        [components/no-pipelines-in-use-view]
        :else
        [default-page-layout/view
         [sync/wait-until-sync-progress
          (if (some #{:oppo/calc-oldest-deal-referrer
                      :oppo/calc-oldest-introducer-firm
                      :oppo/calc-oldest-mandate-firm}
                    (:tenant/fields-in-use @session/tenant))
            sync-progress/COMPLETE
            sync-progress/COMPANIES)
          [:<>
           [components/card-settings-toolbar
            [toolbar args] db/kanban events/close-card-settings!]
           [view view-mode]]]]))))
